import { Injectable } from '@angular/core'

import { ApiService } from '../common/api.service'
import { HttpObjectService } from '../common/http-object.service'

@Injectable()

export class PositionService extends HttpObjectService {
  object = 'position'

  constructor(public apiService: ApiService) {
    super(apiService)
  }
}
